import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const transformacoes = [
  {
    nome: 'Juliana Martins',
    idade: 29,
    profissao: 'Arquiteta',
    foto: 'https://public.readdy.ai/ai/img_res/a10d46aa542ce442c3801897edd5a57c.jpg',
    antes: ['Ansiedade constante', 'Insônia crônica', 'Medo de julgamento'],
    antesDesc: 'Vivia em estado de alerta permanente, com crises que me impediam de apresentar projetos e participar de reuniões importantes.',
    depois: ['Confiança em público', 'Sono reparador', 'Autoestima elevada'],
    depoisDesc: 'Hoje apresento projetos com segurança, durmo tranquilamente e me sinto no controle da minha vida profissional e pessoal.',
    tempo: '2 meses',
    tecnica: 'Técnica Swish + Diário de Gratidão',
  },
  {
    nome: 'Marcia Torres',
    idade: 38,
    profissao: 'VP Marketing',
    foto: 'https://readdy.ai/api/search-image?query=successful%20professional%20Brazilian%20woman%20VP%20executive%2038%20years%20old%20confident%20dark%20hair%20elegant%20minimal%20dark%20background%20luxury%20premium%20corporate%20portrait%20strong%20feminine&width=400&height=500&seq=marcia-antes-depois-02&orientation=portrait',
    antes: ['Síndrome do impostor', 'Burnout silencioso', 'Autossabotagem'],
    antesDesc: 'Sabotava minhas próprias oportunidades por medo de não ser suficientemente boa. Perdi promoções importantes por insegurança.',
    depois: ['Liderança assertiva', 'Clareza e foco', 'Carreira em expansão'],
    depoisDesc: 'Promovida a VP global em 6 meses. Lidero com autoridade genuína e tomo decisões estratégicas sem medo.',
    tempo: '3 meses',
    tecnica: 'Ressignificação + Ancoragem Emocional',
  },
  {
    nome: 'Ana Clara Ribeiro',
    idade: 46,
    profissao: 'Médica e Palestrante',
    foto: 'https://readdy.ai/api/search-image?query=elegant%20sophisticated%20Brazilian%20woman%20medical%20professional%2046%20years%20old%20warm%20smile%20confident%20minimal%20background%20warm%20tones%20authoritative%20portrait%20high%20quality&width=400&height=500&seq=ana-antes-depois-03&orientation=portrait',
    antes: ['Trauma não resolvido', 'Relacionamentos tóxicos', 'Esgotamento total'],
    antesDesc: 'Carregava traumas de infância que afetavam todos os meus relacionamentos. Dificuldade em dizer não, esgotamento constante.',
    depois: ['Cura emocional', 'Limites saudáveis', 'Identidade reconectada'],
    depoisDesc: 'Ressignifiquei meu passado, criou sua clínica própria e reduziu a jornada em 40%. Vivo com propósito de volta.',
    tempo: '4 meses',
    tecnica: 'Linha do Tempo + Submodalidades',
  },
];

function AntesDepois() {
  return (
    <section className="py-24 bg-[#0d0d0d] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(201,164,64,0.04),transparent_50%)]"></div>

      <div className="container mx-auto px-4 relative z-10">
        <ScrollRevealWrapper animation="fade-up">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-4 mb-6">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-gold-500/60"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.35em] uppercase font-['Montserrat']">
                Transformações Reais
              </span>
              <div className="h-px w-10 bg-gradient-to-l from-transparent to-gold-500/60"></div>
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-white mb-5 leading-tight">
              Antes e Depois:<br />
              <span className="text-gold-400">Vidas Transformadas</span>
            </h2>
            <p className="text-lg text-white/50 max-w-2xl mx-auto leading-relaxed font-['Montserrat'] font-light">
              Pessoas reais que superaram seus maiores desafios emocionais e conquistaram a vida que sempre quiseram
            </p>
          </div>
        </ScrollRevealWrapper>

        <div className="space-y-10 max-w-5xl mx-auto">
          {transformacoes.map((pessoa, index) => (
            <ScrollRevealWrapper key={index} animation="fade-up" delay={0.1 * index}>
              <div className="group bg-[#111111] border border-gold-500/10 rounded-2xl overflow-hidden hover:border-gold-500/25 transition-all duration-500">
                <div className="grid md:grid-cols-2 gap-0">
                  {/* ANTES */}
                  <div className="relative bg-[#0d0d0d] p-8 border-r border-gold-500/8">
                    <div className="flex items-center gap-3 mb-6">
                      <span className="px-4 py-1.5 bg-white/5 border border-white/10 rounded-full text-xs font-bold text-white/50 font-['Montserrat'] tracking-widest uppercase">
                        Antes
                      </span>
                    </div>

                    <div className="flex items-start gap-5 mb-6">
                      <div className="w-20 h-20 rounded-xl overflow-hidden border border-white/10 flex-shrink-0 grayscale">
                        <img src={pessoa.foto} alt={pessoa.nome} className="w-full h-full object-cover" />
                      </div>
                      <div>
                        <h3 className="font-display text-lg font-bold text-white/70">{pessoa.nome}</h3>
                        <p className="text-white/35 text-xs font-['Montserrat']">{pessoa.profissao}, {pessoa.idade} anos</p>
                      </div>
                    </div>

                    <div className="space-y-2 mb-5">
                      {pessoa.antes.map((item, idx) => (
                        <div key={idx} className="flex items-center gap-3 px-3 py-2 bg-white/4 border border-white/6 rounded-lg">
                          <i className="ri-close-circle-line text-white/25 flex-shrink-0"></i>
                          <span className="text-white/45 text-xs font-['Montserrat']">{item}</span>
                        </div>
                      ))}
                    </div>
                    <p className="text-white/35 text-xs italic leading-relaxed font-['Montserrat']">"{pessoa.antesDesc}"</p>
                  </div>

                  {/* DEPOIS */}
                  <div className="relative bg-gradient-to-br from-[#0f0c00] to-[#111111] p-8">
                    <div className="flex items-center gap-3 mb-6">
                      <span className="px-4 py-1.5 bg-gold-500/15 border border-gold-500/25 rounded-full text-xs font-bold text-gold-400 font-['Montserrat'] tracking-widest uppercase">
                        Hoje
                      </span>
                    </div>

                    <div className="flex items-start gap-5 mb-6">
                      <div className="w-20 h-20 rounded-xl overflow-hidden border border-gold-500/20 flex-shrink-0">
                        <img src={pessoa.foto} alt={pessoa.nome} className="w-full h-full object-cover" />
                      </div>
                      <div>
                        <h3 className="font-display text-lg font-bold text-white">{pessoa.nome}</h3>
                        <div className="flex items-center gap-1.5 mt-1">
                          <i className="ri-trophy-fill text-gold-400 text-xs"></i>
                          <span className="text-gold-400 text-xs font-semibold font-['Montserrat']">Transformação Completa</span>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-2 mb-5">
                      {pessoa.depois.map((item, idx) => (
                        <div key={idx} className="flex items-center gap-3 px-3 py-2 bg-gold-500/8 border border-gold-500/15 rounded-lg">
                          <i className="ri-checkbox-circle-fill text-gold-400 flex-shrink-0 text-sm"></i>
                          <span className="text-white/70 text-xs font-['Montserrat']">{item}</span>
                        </div>
                      ))}
                    </div>
                    <p className="text-white/55 text-xs leading-relaxed font-['Montserrat'] mb-5">"{pessoa.depoisDesc}"</p>

                    <div className="flex items-center justify-between bg-gold-500/8 border border-gold-500/15 rounded-xl px-4 py-3">
                      <div>
                        <p className="text-gold-400/60 text-xs font-['Montserrat'] uppercase tracking-wider mb-0.5">Tempo</p>
                        <p className="text-white text-sm font-bold">{pessoa.tempo}</p>
                      </div>
                      <div className="h-8 w-px bg-gold-500/15"></div>
                      <div className="text-right">
                        <p className="text-gold-400/60 text-xs font-['Montserrat'] uppercase tracking-wider mb-0.5">Técnica</p>
                        <p className="text-white text-xs font-semibold font-['Montserrat']">{pessoa.tecnica}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollRevealWrapper>
          ))}
        </div>

        {/* CTA */}
        <ScrollRevealWrapper animation="fade-up" delay={0.4}>
          <div className="text-center mt-16">
            <div className="bg-[#111111] border border-gold-500/15 rounded-2xl p-10 max-w-2xl mx-auto">
              <h3 className="font-display text-3xl font-bold text-white mb-4">
                Qual será sua história<br />
                <span className="text-gold-400">de transformação?</span>
              </h3>
              <p className="text-white/45 text-sm mb-8 leading-relaxed font-['Montserrat']">
                Milhares de mulheres já transformaram suas vidas. Agora é a sua vez.
              </p>
              <a
                href="/quiz"
                className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] font-bold rounded-full hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] text-sm tracking-wide"
              >
                Começar Minha Transformação
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}

export default AntesDepois;
